// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__u4DqL"};